import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  sliderWrapper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  sliderInnerWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  slider: {
    width: '300%',
    height: '100%',
    display: 'flex',
    WebkitBackfaceVisibility: 'hidden',
    WebkitPerspective: 1000,
  },
  slide: {
    width: '100%',
    height: '100%',
    transform: 'translateZ(0)',
    display: 'flex',
  },
});

export default useStyles;
